<template>
  <div>
    <customer-list :click-item='clickItem' :is-mobile='true' :customers='customers' :search-mode='searchMode' @submitsearch='handleSubmitSearch($event)'
      :allowed-stores='User.AllowedStores' :selected-platform='storePlatform' :report-mode='reportMode' />
  </div>
</template>

<script>
  import CustomerList from '@/components/CustomerList/CustomerList'
  import {
    CustomerAPIClient
  } from '@/lib/data_access/Customer'

  import {
    mapGetters
  } from 'vuex'

  export default {
    data: function () {
      return {
        customers: [],
        searchMode: false,
        reportMode: false
      }
    },
    computed: {
      ...mapGetters(['User']),
      storePlatform: function () {
        let vm = this;
        console.log(vm.storeInput)
        if (vm.storeInput) {
          return vm.storeInput
        } else {
          return vm.User.AllowedStores[0].AccountPlatformID
        }
      }
    },
    methods: {
      clickItem: function (customer) {
        this.$router.push({
          name: 'Plugin.CustomerProfile',
          query: {
            crmCustomerId: customer.CrmCustomerID
          }
        })
      },
      handleSubmitSearch(searchTerm) {
        let vm = this;
        vm.listLoading = true;
        CustomerAPIClient.postPatternSearch(searchTerm).then(function (data) {

          vm.customers = data;
          vm.listLoading = false
        })
      }
    },
    components: {
      CustomerList
    },
    created() {
      let vm = this;
      let reportType = vm.$route.query.report
      loadReport(reportType, vm.storePlatform).then(function (data) {
        vm.customers = data
        if (reportType && reportType.toLowerCase() == 'search') {
          vm.searchMode = true;
        } else {
          vm.searchMode = false;
        }

        if (reportType.toLowerCase == 'search' || reportType.toLowerCase() == 'recent') {
          vm.reportMode = false
        } else {
          vm.reportMode = true;
        }
      })
    },
    watch: {
      '$route.query.report': function (newVal) {
        let vm = this;
        let promise;
        if (newVal) {
          loadReport(newVal, vm.storePlatform).then(function (data) {
            vm.customers = data
            if (reportType && reportType.toLowerCase() == 'search') {
              vm.searchMode = true;
            } else {
              vm.searchMode = false;
            }
            if (newVal.toLowerCase == 'search' || newVal.toLowerCase() == 'recent') {
              vm.reportMode = false
            } else {
              vm.reportMode = true;
            }
          })

        }
      }
    }
  }

  function loadReport(newVal, platformId) {
    let promise;
    switch (newVal) {
      case 'highIntensity':
        promise = CustomerAPIClient.getHighIntensityActiveLeadsReport(platformId)
        break
      case 'losingIntensity':
        promise = CustomerAPIClient.getActiveLeadsLosingIntensityReport(platformId)
        break
      case 'lostLeads':
        promise = CustomerAPIClient.getLostLeadsInMarketReport(platformId)
        break
      case 'soldBim':
        promise = CustomerAPIClient.getSoldCustomersBackInMarketReport(platformId)
        break;
      case 'search':
        promise = new Promise((resolve, reject) => {
          resolve([])
        });
        break;
      case 'recent':
      default:
        promise = CustomerAPIClient.getRecentlyViewedReport()
        break;
    }
    return promise;
  }

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/views/Plugin/CustomerList/CustomerList.vue